import { LookupItem } from "@data-types";
import {
	CountryDataType,
	LanguageDataType,
	RegionDataType,
} from "@data-types/membership/registration";
import { httpClient } from "@utils";
import { getApiRequestContext } from "@utils/api-config";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { ApiRequestContextData } from "@utils/api-config/types";

class PlatformPartnerLookupApiService {
	static get baseUrl() {
		return `${WEBPACK_BASE_ADDRESS}platform/tw/partners/lookups`;
	}

	static getRequestHeaders = (
		options: ApiRequestContextData = getApiRequestContext()
	) => {
		const appHeaders = getApplicationRequestHeaders(options);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static findTitles(): Promise<LookupItem[]> {
		return httpClient.get(
			`${this.baseUrl}/user-titles?translate=true`,
			this.getRequestHeaders()
		);
	}

	static findCountries(): Promise<CountryDataType[]> {
		// TODO: TEMP translation bug
		// Restore when fixed: `${this.baseUrl}/countries?sort=name|asc&fields=id,name,nationality,abrv&rpp=1000&translate=true`
		return httpClient.get(
			`${this.baseUrl}/countries?sort=name|asc&rpp=1000&translate=true`,
			this.getRequestHeaders()
		);
	}

	static findLanguages(isos: string): Promise<LanguageDataType[]> {
		return httpClient.get(
			`${this.baseUrl}/contact-languages?sort=name|asc&rpp=1000&translate=true&isos=${isos}`,
			this.getRequestHeaders()
		);
	}

	static findCountryRegions(countryId?: string): Promise<RegionDataType[]> {
		const params = new URLSearchParams({
			sort: "name|asc",
			rpp: "1000",
			translate: "true",
		});
		if (countryId) {
			params.set("countryId", countryId);
		}
		return httpClient.get(
			`${this.baseUrl}/regions?${params.toString()}`,
			this.getRequestHeaders()
		);
	}
}

export default PlatformPartnerLookupApiService;
